import Select from "react-select";
import ReactQuill from "react-quill";
import { useHistory } from "react-router";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";

import api from "services/api";
import Swal from "sweetalert2";
import Button from "components/CustomButton/CustomButton";
import FormInputs from "components/FormInputs/FormInputs";

const CreateNotificationLeads = () => {
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [candidates, setCandidates] = useState('');
  const [description, setDescription] = useState('');
  const [selectedCandidate, setSelectedCandidate] = useState('');

  const history = useHistory();
  const appId = localStorage.getItem("idApp");

  useEffect(() => {
    getCandidates();
  }, []);

  async function getCandidates() {
    try {
      const response = await api.get(`${appId}/candidates/get_by_roles`);

      const candidates = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setCandidates(candidates);

      return candidates;
    } catch (error) {
      console.error(error);
    }
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("description", description);
    formData.append("candidate_id", selectedCandidate);
    
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    
    try {
      await trackPromise(
        api.post(
          `${appId}/leadership_news`,
          formData,
          config
        )
      );

      Toast.fire({
        icon: "success",
        title: "Comunicação criada com sucesso!"
      });

      history.push({ pathname: `/admin/lead-notifications` });
    } catch (error) {
      console.error(error);

      Toast.fire({
        icon: "error",
        title: "Erro ao criar a comunicação."
      });
    }
  }

  const Toast = Swal.mixin({
    toast: true,
    timer: 3000,
    position: "top-end",
    timerProgressBar: true,
    showConfirmButton: false,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  return (
    <div className="content">
      <Row>
        <Col md={12}>
        <p>Criar Comunicação</p>
          <form onSubmit={submitHandler} encType="multipart/form-data">
            <Row>
              <Col md={6}>
                <FormInputs
                  ncols={["col-md-12"]}
                  properties={[
                    {
                      type: "text",
                      required: true,
                      label: "Título",
                      defaultValue: title,
                      bsClass: "form-control",
                      placeholder: "nforme um título para a comunicação",
                      onChange: (event) => setTitle(event.target.value),
                    }
                  ]}
                />
              </Col>

              <Col md={6}>
                <label>Selecione o candidato</label>
                <Select
                  isClearable
                  isSearchable
                  name="candidate"
                  options={candidates}
                  placeholder="Enviar comunicação para líderes do candidato selecionado"
                  isDisabled={candidates.length < 2}
                  noOptionsMessage={() => "Dados não encontrados"}
                  onChange={(option) =>
                    setSelectedCandidate(option ? option.value : "")
                  }
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormInputs
                  ncols={["col-md-12"]}
                  properties={[
                    {
                      label: "Descrição",
                      type: "text",
                      bsClass: "form-control",
                      placeholder: "Informe uma descrição para a comunicação",
                      required: true,
                      defaultValue: description,
                      onChange: (event) => setDescription(event.target.value),
                    },
                  ]}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup controlId="formControlsTextarea">
                  <ControlLabel>Conteúdo</ControlLabel>
                  <ReactQuill
                    theme="snow"
                    value={content}
                    onChange={(value) => setContent(value)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="clearfix" />
            <Button bsStyle="danger" fill onClick={() => window.history.back()}>
              Voltar
            </Button>
            <Button bsStyle="info" pullRight fill type="submit">
              Salvar
            </Button>
          </form>
        </Col>
      </Row>
    </div>
  )
}

export default CreateNotificationLeads;